import React, { useState } from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Paper,
  Typography,
  Chip
} from '@mui/material';
import {
  Search,
  Clear,
  FilterList
} from '@mui/icons-material';

const QuickSearch = ({
  onSearch,
  onClear,
  placeholder = "Buscar transações...",
  showFilterButton = true,
  onFilterClick
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (value) => {
    setSearchTerm(value);
    onSearch(value);
  };

  const handleClear = () => {
    setSearchTerm('');
    onClear();
  };

  return (
    <Paper
      elevation={2}
      sx={{
        p: { xs: 1.5, md: 2 },
        mb: 3,
        borderRadius: 3,
        backgroundColor: '#FAFAFA',
        border: '1px solid #E0E0E0'
      }}
    >
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1, md: 2 },
        flexDirection: { xs: 'column', sm: 'row' }
      }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: '#1976D2' }} />
              </InputAdornment>
            ),
            endAdornment: searchTerm && (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClear}
                  edge="end"
                  size="small"
                  sx={{ color: '#666' }}
                >
                  <Clear />
                </IconButton>
              </InputAdornment>
            ),
            sx: {
              backgroundColor: 'white',
              borderRadius: 2,
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: '#1976D2',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#1976D2',
                },
              }
            }
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            }
          }}
        />

        {showFilterButton && (
          <IconButton
            onClick={onFilterClick}
            sx={{
              backgroundColor: '#1976D2',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565C0',
              },
              minWidth: { xs: 40, md: 48 },
              height: { xs: 40, md: 48 },
              borderRadius: 2,
              width: { xs: '100%', sm: 'auto' }
            }}
          >
            <FilterList />
          </IconButton>
        )}
      </Box>

      {searchTerm && (
        <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Buscando por:
          </Typography>
          <Chip
            label={searchTerm}
            onDelete={handleClear}
            size="small"
            sx={{
              backgroundColor: '#E3F2FD',
              color: '#1976D2',
              '& .MuiChip-deleteIcon': {
                color: '#1976D2',
                '&:hover': {
                  color: '#1565C0',
                }
              }
            }}
          />
        </Box>
      )}
    </Paper>
  );
};

export default QuickSearch;
